import { AlbumWidget } from "../../../components";
import { buildingPermitPhotoSections } from "../../../constants/buildingPermitPhotos";

interface PermitPhotosProps {
    taskId: string;
    projectId: string;
}

export function PermitPhotos(props: PermitPhotosProps) {
    const { taskId, projectId } = props;
    return (
        <AlbumWidget
            sections={buildingPermitPhotoSections}
            taskId={taskId}
            projectId={projectId}
            assetType="TASK:BUILDING_PERMIT"
            heading="Permit Photos"
            subheading="Please upload the required photos for each category below to document the building permit process."
        />
    );
}
